export default function SyncableSectionTitleChangeController(
) {
  // const vm = this;

  _activate();

  function _activate() {
    var z = 1;
  }
}

SyncableSectionTitleChangeController.$inject = [
];
